import {
    GET_CURRENCY_DEFINITIONS,
    GET_CURRENCY_DEFINITIONS_SUCCESS,
    GET_CURRENCY_DEFINITIONS_SYNC,
    GET_CURRENCY_DEFINITIONS_SYNC_SUCCESS,
    ADD_CURRENCY_DEFINITION,
    ADD_CURRENCY_DEFINITION_SUCCESS,
    UPDATE_CURRENCY_DEFINITION,
    UPDATE_CURRENCY_DEFINITION_SUCCESS,
    DELETE_CURRENCY_DEFINITION,
    DELETE_CURRENCY_DEFINITION_SUCCESS,
    CLIENT_API_ERROR
  
  } from "./actionTypes"
  
  
  
  
  export const getCurrencyList = () => ({
    type: GET_CURRENCY_DEFINITIONS,
  })
  
  export const getCurrencyListSuccess = record => ({
    type: GET_CURRENCY_DEFINITIONS_SUCCESS,
    payload: record,
  })

  export const getCurrencyListSync = () => ({
    type: GET_CURRENCY_DEFINITIONS_SYNC,
  })
  
  export const getCurrencyListSuccessSync = record => ({
    type: GET_CURRENCY_DEFINITIONS_SYNC_SUCCESS,
    payload: record,
  })
  
  export const addCurrency = record => ({
    type: ADD_CURRENCY_DEFINITION,
    payload: record,
  })
  
  export const addCurrencySuccess = record => ({
    type: ADD_CURRENCY_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const updateCurrency = record => ({
    type: UPDATE_CURRENCY_DEFINITION,
    payload: record,
  })
  
  export const updateCurrencySuccess = record => ({
    type: UPDATE_CURRENCY_DEFINITION_SUCCESS,
    payload: record,
  })
  
  
  export const deleteCurrency = guid => ({
    type: DELETE_CURRENCY_DEFINITION,
    payload: guid,
  })
  
  export const deleteCurrencySuccess = guid => ({
    type: DELETE_CURRENCY_DEFINITION_SUCCESS,
    payload: guid,
  })
  
  export const currencyApiError = error => {
    return {
      type: CLIENT_API_ERROR,
      payload: error,
    }
  }
  
  